import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';

function FullPageMessage({ icon, iconLabel = 'icon', main = '', sub = '' }) {
  const [parent, setParent] = useState(null);
  useEffect(() => {
    const mainContent = document.getElementById('main-content');
    if (mainContent) {
      setParent(mainContent);
    }
  }, []);

  if (!parent) return null;

  const el = (
    <Message>
      <span role="img" aria-label={iconLabel}>
        {icon}
      </span>
      <div>{main}</div>
      <div>{sub}</div>
    </Message>
  );
  return createPortal(el, parent);
}

export default observer(FullPageMessage);

const Message = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  width: 100%;
  text-align: center;
  > span {
    font-size: 32px;
    margin-bottom: 1em;
  }

  > div:nth-child(2) {
    color: #6b6b6b;
    font-size: 28px;
    line-height: 40px;
  }
  > div:nth-child(3) {
    color: #8c9cb0;
    font-size: 18px;
    line-height: 24px;
  }
`;
